// extracted by mini-css-extract-plugin
export default {"rootWrapper":"LeftSidebarPageLayout_rootWrapper__ZprLt","sidebarHolder":"LeftSidebarPageLayout_sidebarHolder__MBjJb","contentHolder":"LeftSidebarPageLayout_contentHolder__2rmqi"};